<template>
  <div>
    <section>
    <v-layout row wrap>
      <v-flex xs12 md4>
        <v-text-field
          v-model="filtros.transaction_id"
          label="Folio"
          outlined
          placeholder="INTRODUZCA Folio"
          @keyup.enter="buscartransaction_id(filtros.transaction_id)"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md3 class="d-flex">
        <v-btn
          color="primary"
          @click="buscartransaction_id"
          class="mt-2 mr-2"
        >
          BUSCAR
        </v-btn>
        <v-btn
          color="success"
          @click="abrirModalPromocion"
          class="mt-2"
          fab
          small
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 md5>
        <v-text-field
          v-model="filtros.filtro"
          label="FILTRAR"
          outlined
          placeholder="FILTRAR POR"
          @input="filtrarDatos"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row class="mt-4">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="muestras"
              :items-per-page="15"
              :search="filtros.filtro"
              class="elevation-1 custom-header"
              :height="$vuetify.breakpoint.height * 0.65 + 'px'"
            >
              <template v-slot:item="props">
                <tr>
                  <td class="text-center">
                    <a href="#" class="text-decoration-none primary--text" @click.prevent="verHistorial(props.item)">
                      {{ props.item.transaction_id }}
                    </a>
                  </td>
                  <td class="text-center">
                    <a
                      v-if="props.item.PDF_Toma"
                      :href="props.item.PDF_Toma"
                      target="_blank"
                      class="text-decoration-none primary--text"
                    >
                      {{ props.item.Paciente }}
                    </a>
                    <span v-else>{{ props.item.Paciente }}</span>
                  </td>
                  <td class="text-center">
                    <span>{{ props.item.FechaSolicitud }}</span>
                  </td>
                  <td class="text-center">{{ props.item.FechaCita }}</td>
                  <td class="text-center">
                    <v-icon 
                      v-if="props.item.FechaMuestra == null" 
                      color="primary"
                      @click="abrirModalFecha(props.item, 'Muestra')"
                    >
                      mdi-calendar
                    </v-icon>
                    <a 
                      v-else 
                      href="#" 
                      class="text-decoration-none primary--text"
                      @click.prevent="abrirModalFecha(props.item, 'Muestra')"
                    >
                      {{ props.item.FechaMuestra }}
                    </a>
                  </td>
                  <td class="text-center">
                    <template v-if="props.item.EstatusDAO === 'EN ESPERA'">
                      <v-icon
                        v-if="props.item.FechaMuestra"
                        color="primary"
                        class="calendar-icon"
                        @click="abrirModalFecha(props.item, 'Recepcion')"
                      >
                        mdi-calendar
                      </v-icon>
                      <v-icon
                        v-else
                        color="grey lighten-1"
                        class="calendar-icon disabled-calendar"
                      >
                        mdi-calendar
                      </v-icon>
                    </template>
                    <a 
                      v-else 
                      href="#" 
                      class="text-decoration-none primary--text"
                      @click.prevent="abrirModalFecha(props.item, 'Recepcion')"
                    >
                      {{ props.item.FechaRecepcion }}
                    </a>
                  </td>
                  <td class="text-center">
                    <v-chip
                      :color="getEstatusColor(props.item.EstatusDAO)"
                      text-color="white"
                      small
                    >
                      {{ props.item.EstatusDAO }}
                    </v-chip>
                  </td>
                  <td class="text-center">
                    <v-icon v-if="props.item.EstatusDAO === 'EN PROCESO' || props.item.EstatusDAO === 'EN ESPERA'" color="primary">mdi-clock-outline</v-icon>
                    <v-icon v-else-if="props.item.EstatusDAO === 'PROCESADO' || props.item.EstatusDAO === 'ENVIADO'" color="primary">mdi-check</v-icon>
                    <span v-else>{{ props.item.Validado }}</span>
                  </td>
                  <td class="text-center">
                    <template v-if="props.item.EstatusDAO === 'PROCESADO' || props.item.EstatusDAO === 'ENVIADO'">
                      <v-icon color="primary" @click="enviarResultados(props.item)" class="mr-2">
                        {{ props.item.EstatusDAO === 'ENVIADO' ? 'mdi-email-sync' : 'mdi-email' }}
                      </v-icon>
                      <v-icon color="primary" @click="verResultados(props.item)">mdi-eye</v-icon>
                    </template>
                    <v-icon v-else-if="props.item.EstatusDAO === 'EN ESPERA' || props.item.EstatusDAO === 'EN PROCESO'" color="primary">mdi-clock-outline</v-icon>
                    <span v-else>{{ props.item.reporteResultados }}</span>
                  </td>
                </tr>
              </template>

              <template v-slot:no-data>
                No hay datos para mostrar
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </section>

  <v-dialog v-model="modalFecha" max-width="500px">
  <v-card>
    <v-card-title class="headline">{{ tituloModalFecha }}</v-card-title>
    <v-card-text>
      <v-date-picker v-model="fechaSeleccionada" full-width></v-date-picker>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="modalFecha = false">Cancelar</v-btn>
      <v-btn color="blue darken-1" text @click="guardarFecha">Guardar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <v-dialog v-model="modalHistorial" max-width="850px">
      <v-card>
        <v-card-title class="headline">Historial de Cambios</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersHistorial"
            :items="historialItems"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:no-data>
              No hay datos para mostrar
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="modalHistorial = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Promoción -->
    <PromocionModal 
      v-model="modalPromocion"
      @promocionGuardada="onPromocionGuardada"
    />
  </div>
</template>

<script>
import axios from 'axios';

import ServicioRecepcionDAO from "../../services/recepciondao";
import ServicioCertificadoDAO from "../../services/certificadodao";
import PromocionModal from "../../components/PromocionModal.vue";

export default {
  name: "recepcion-dao",
  components: {
    PromocionModal
  },
  computed: {
    tituloModalFecha() {
      if (this.fechaTipo === 'Muestra') {
        return 'Actualizar Fecha de Toma';
      }
      if (this.fechaTipo === 'Recepcion') {
        return 'Actualizar Fecha de Recepción';
      }
      return 'Actualizar Fecha';
    }
  },
  data() {
    return {
      loading: false,
      modalFecha: false,
      modalPromocion: false,
      fechaSeleccionada: null,
      muestraSeleccionada: null,
      fechaTipo: null,
      filtros: {
        transaction_id: "",
        filtro: ""
      },
      headers: [
        { text: "Folio", value: "transaction_id", align: "center" },
        { text: "Paciente", value: "Paciente", align: "center" },
        { text: "Fecha Solicitud", value: "FechaSolicitud", align: "center" },
        { text: "Fecha Cita", value: "FechaCita", align: "center" },
        { text: "Fecha Toma", value: "FechaMuestra", align: "center" },
        { text: "Fecha Recepción", value: "FechaRecepcion", align: "center" },
        { text: "Estatus", value: "EstatusDAO", align: "center" },
        { text: "Validado", value: "Validado", align: "center" },
        { text: "Reporte de resultados", value: "reporteResultados", align: "center" }
      ],
      muestras: [],
      modalHistorial: false,
      historialItems: [],
      headersHistorial: [
        { text: "Fecha", value: "Fecha", align: "center" },
        { text: "Evento", value: "Evento", align: "left" },
        { text: "Actvidad", value: "Actividad", align: "left" }
      ]
    };
  },
  async created() {
    await this.cargarReporte();
  },
  methods: {
    async cargarReporte() {
      try {
        this.loading = true;
        const response = await ServicioRecepcionDAO.reporte();
        if (response?.data?.result === 1 && response?.data?.tables > 0 && Array.isArray(response?.data?.data?.Table0)) {
          this.muestras = response.data.data.Table0;
        } else {
          console.warn('La respuesta no contiene datos válidos');
          this.muestras = [];
        }
      } catch (error) {
        console.error('Error al cargar el reporte:', error);
        this.muestras = [];
      } finally {
        this.loading = false;
      }
    },
    async verResultados(item) {
      window.open(this.config.RutaResultados + item.PDF, "_blank");
    },
    
    async enviarResultados(item) {
      try {
        this.loading = true;
        
        // Preparar los datos para enviar al servicio
        const datos = {
          id: item.id,
          transaction_id: item.transaction_id,
          Paciente: item.Paciente,
          PDF: item.PDF,
          Correo: item.Correo,
          Medico_Correo: item.Medico_Email
        };
        
        // Llamar al servicio de envío de certificados
        const response = await ServicioCertificadoDAO.enviar(datos);
        
        if (response?.data?.result === 1) {
          // Actualizar el estado del item a ENVIADO
          item.EstatusDAO = 'ENVIADO';
          this.$root.mensajeExito = 'Resultados enviados correctamente por correo';
        } else {
          this.$root.mensajeError = 'Error al enviar los resultados: ' + (response?.data?.mensaje || 'Error desconocido');
        }
      } catch (error) {
        console.error('Error al enviar resultados:', error);
        this.$root.mensajeError = 'Error al enviar los resultados por correo';
      } finally {
        this.loading = false;
      }
    },
    abrirModalFecha(item, fechaTipo) {
      if (fechaTipo === 'Recepcion' && !item.FechaMuestra) {
        this.$root.mensajeError = 'Debe capturar la fecha de muestra antes de actualizar la fecha de recepción';
        return;
      }
      this.muestraSeleccionada = item;
      this.fechaSeleccionada = this.fechaPicker(this.$root.hoy);
      this.modalFecha = true;
      this.fechaTipo = fechaTipo;
    },
    async guardarFecha() {
      console.log(this.fechaSeleccionada);
      console.log(this.muestraSeleccionada);
      console.log(this.fechaTipo);

      if (this.fechaSeleccionada && this.muestraSeleccionada && this.fechaTipo) {
        try {
          // Split the selected date (YYYY-MM-DD) into parts
          const [year, month, day] = this.fechaSeleccionada.split('-');
          
          // Format as DD/MM/YYYY without timezone conversion
          const formattedDate = `${day}/${month}/${year}`;
          const formattedDateSQL = `${year}-${month}-${day}`;
          
          if(this.fechaTipo == "Recepcion"){
            const response = await ServicioRecepcionDAO.actualizarFechaRecepcion({
              id: this.muestraSeleccionada.id,
              FechaRecepcion: formattedDateSQL
            });

            if (response?.data?.result === 1) {
              // Update local data only after successful API call
              this.muestraSeleccionada.FechaRecepcion = formattedDate;
              this.muestraSeleccionada.EstatusDAO = 'EN PROCESO';
              this.$root.mensajeExito = 'Fecha de recepción actualizada correctamente';
          } else {
            this.$root.mensajeError = 'Error al actualizar la fecha de recepción';
          }

          }

          if(this.fechaTipo == "Muestra"){
            const response = await ServicioRecepcionDAO.actualizarFechaMuestra({
              id: this.muestraSeleccionada.id,
              FechaMuestra: formattedDateSQL
            });

            if (response?.data?.result === 1) {
              // Update local data only after successful API call
              this.muestraSeleccionada.FechaMuestra = formattedDate;
              this.$root.mensajeExito = 'Fecha de muestra actualizada correctamente';
            } else {
              this.$root.mensajeError = 'Error al actualizar la fecha de muestra';
            }
          }

          // Call the API to update the date
          /*
          const response = await ServicioRecepcionDAO.actualizarFechaRecepcion({
            id: this.muestraSeleccionada.id,
            FechaRecepcion: formattedDateSQL
          });
          
          if (response?.data?.result === 1) {
            // Update local data only after successful API call
            this.muestraSeleccionada.FechaRecepcion = formattedDate;
            this.muestraSeleccionada.EstatusDAO = 'EN PROCESO';
            this.$root.mensajeExito = 'Fecha de recepción actualizada correctamente';
          } else {
            this.$root.mensajeError = 'Error al actualizar la fecha de recepción';
          }
          */
        } catch (error) {
          console.error('Error al actualizar fecha:', error);
          this.$root.mensajeError = 'Error al actualizar la fecha';
        } finally {
          // Cerrar modal y resetear variables
          this.modalFecha = false;
          this.fechaSeleccionada = null;
          this.muestraSeleccionada = null;
          this.fechaTipo = null;
        }
      }
    },
    getEstatusColor(estatus) {
      switch (estatus) {
        case "EN PROCESO":
          return "warning";
        case "EN ESPERA":
          return "purple";
        case "PROCESADO":
          return "success";
        case "ENVIADO":
          return "info";
        default:
          return "grey";
      }
    },
    async buscartransaction_id() {
      
      if (!this.filtros.transaction_id) {
        this.$root.mensajeError = 'Por favor ingrese un transaction_id para buscar.';
        return;
      }
  
      this.loading = true;
      try {

        const openPayResponse = await ServicioRecepcionDAO.obtenerInfo_OpenPay({ id: this.filtros.transaction_id });
        
        if (openPayResponse.data.result === 1) {
         

          const registro = openPayResponse.data.data.Table0;

          // Validar si el transaction_id ya existe
          //const transaction_idExistente = this.muestras.some(muestra => muestra.transaction_id === registro[0].transaction_id);
          //if (transaction_idExistente) {
          if (registro[0].nuevo == 0) {
            this.$root.mensajeAviso = `El Folio ${registro[0].transaction_id} ya está registrado.`;
            return;
          }

          const newRecord = {
            transaction_id: registro[0].transaction_id,
            Paciente: registro[0].Paciente,
            FechaCita: registro[0].FechaCita,
            FechaSolicitud: registro[0].FechaSolicitud,
            FechaMuestra: registro[0].FechaMuestra,
            FechaRecepcion: registro[0].FechaRecepcion,
            Validado: registro[0].Validado,
            Certificado: registro[0].Certificado,
            EstatusDAO: '',
            estatus: 'EN ESPERA',
            responsableSanitario: '',
            reporteResultados: ''
          };
          
          // Add to the beginning of the array
          this.muestras.unshift(registro[0]);

          return;

        }

        if (openPayResponse.data.result === 2) {
          this.$root.mensajeAviso = 'Folio no encontrado.';
        }

        if (openPayResponse.data.result === 3) {
          this.$root.mensajeError = 'Error al procesar: ' + openPayResponse.data.mensaje;
        }
      } catch (openPayError) {
            this.$root.$emit('mostrarConfirmar', {
              titulo: 'Error',
              mensaje: 'Error al obtener información de OpenPay. Por favor intente nuevamente. ' + openPayError,
              resolve: () => {},
              reject: () => {}
            });
          }  
      },
    filtrarDatos() {
      // La búsqueda se maneja automáticamente por v-data-table a través de la propiedad :search
      // No es necesario implementar lógica adicional ya que v-data-table maneja el filtrado
      // Solo mantenemos el console.log para debugging si es necesario
      console.log("Filtrando datos:", this.filtros.filtro);
    },
    async verHistorial(item) {
      try {
        this.loading = true;
        const response = await ServicioRecepcionDAO.historialCambios({ id: item.id });
        
        if (response?.data?.result === 1 && response?.data?.tables > 0) {
          this.historialItems = response.data.data.Table0;
          this.modalHistorial = true;
        } else {
          this.$root.mensajeError = 'No se pudo obtener el historial de cambios';
        }
      } catch (error) {
        console.error('Error al obtener historial:', error);
        this.$root.mensajeError = 'Error al obtener el historial de cambios';
      } finally {
        this.loading = false;
      }
    },
    abrirModalPromocion() {
      this.modalPromocion = true;
    },
    onPromocionGuardada(promocionData) {
      console.log('Datos de promoción:', promocionData);

      // Crear el registro completo con todos los campos necesarios para la tabla
      const nuevoRegistro = {
        id: promocionData.id,
        transaction_id: promocionData.folio,
        Paciente: promocionData.nombrePaciente,
        FechaSolicitud: promocionData.fechaPagoFormated,
        FechaCita: promocionData.fechaTomaFormated,
        FechaMuestra: promocionData.fechaMuestraFormated,
        FechaRecepcion: promocionData.fechaRecepcionFormated,
        EstatusDAO: 'EN PROCESO',
        Validado: null,
        reporteResultados: null,
        PDF: null,
        PDF_Toma: null,
        Correo: null
      };

      // Agregar el registro al principio de la lista
      this.muestras.unshift(nuevoRegistro);

      this.$root.mensajeExito = 'Promoción registrada exitosamente';
    }
  },
};
</script>

<style scoped>
.v-data-table ::v-deep th {
  background-color: #204871 !important;
  color: white !important;
  font-weight: bold;
  text-align: center !important;
}

.calendar-icon {
  cursor: pointer;
}

.disabled-calendar {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
</style>

<style>
.custom-header th {
  height: 48px !important;
  font-weight: bold;
}
</style>
